import React, { FC, ReactNode, useMemo } from 'react';
import { Button } from 'ncoded-component-library';
import classNames from 'classnames';
import ArrowdownIcon from 'icons/Arrowdown.icon';
import SortIcon from 'icons/Sort.icon';
import ResolvePopup from 'components/ResolvePopup';
import { getIsDesc, getIsSortApplied, getSortValue } from 'utils';

import './SortingButton.styles.scss';

type SortingButtonProps = {
  className?: string;
  content?: ReactNode;
  sortingValue: string;
  popupContent?: string;
  disabled?: boolean;
  sort?: string;
  ascDefault?: boolean; // smallest value first
  updateSort: (sortValue: string) => void;
};

const SortingButton: FC<SortingButtonProps> = ({
  className,
  content,
  sortingValue,
  popupContent,
  sort,
  disabled,
  ascDefault = true,
  updateSort,
}) => {
  const isDesc = getIsDesc(sort);

  const isSelected = getIsSortApplied(sort, sortingValue);

  const sortContent = useMemo(
    () => (
      <>
        {content}
        {sortingValue && (
          <Button
            disabled={disabled}
            onClick={() => {
              if (isSelected) {
                updateSort(getSortValue(sortingValue, !isDesc));
                return;
              }

              updateSort(getSortValue(sortingValue, !ascDefault));
            }}
            className={classNames('sortable-button--icons', {
              selected: isSelected,
              rotated: !isDesc,
            })}
          >
            {isSelected ? (
              <ArrowdownIcon />
            ) : (
              <>
                <SortIcon /> <SortIcon />
              </>
            )}
          </Button>
        )}
      </>
    ),
    [
      content,
      sortingValue,
      ascDefault,
      isSelected,
      isDesc,
      disabled,
      updateSort,
    ],
  );

  return (
    <div
      className={classNames('sortable-button', className, {
        selected: isSelected,
      })}
    >
      {popupContent ? (
        <ResolvePopup popupContent={popupContent} onHover preferUpwards>
          {sortContent}
        </ResolvePopup>
      ) : (
        sortContent
      )}
    </div>
  );
};

export default SortingButton;
